import { render, staticRenderFns } from "./JobDetailsView.htm?vue&type=template&id=35bf19d4&scoped=true&"
import script from "./JobDetailsView.ts?vue&type=script&lang=js&"
export * from "./JobDetailsView.ts?vue&type=script&lang=js&"
import style0 from "./JobDetailsView.scss?vue&type=style&index=0&id=35bf19d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bf19d4",
  null
  
)

export default component.exports